module.exports = __webpack_public_path__ + "53fe2d69a41147698391bca07c03e447.svg";